import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-student-image-dialog',
  templateUrl: './student-image-dialog.component.html',
  styleUrls: ['./student-image-dialog.component.css']
})
export class StudentImageDialogComponent implements OnInit {

    image: any;
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<StudentImageDialogComponent>) { }

  ngOnInit() {
      this.image = this.data.studentImage;
  }

    closeClick() {
        this.dialogRef.close();
    }

    onRightClick($event: MouseEvent) {
        return false;
    }
}
